/**
 * ShareBtn.jsx
 * Created by Destin Frasier on 03/27/18.
 */

import React from 'react';

export default class ShareBtn extends React.Component {
    constructor(props) {
        super(props);

        this.shareThis = null;
    }

    componentDidMount() {
        this.loadShareThis();
    }

    componentWillUnmount() {
        this.shareThis = null;
    }

    loadShareThis = () => {
        return new Promise((resolve) => {
            // Create a script that loads ShareThis code
            this.shareThis = document.createElement("script");
            this.shareThis.async = 'async';
            this.shareThis.src = '//platform-api.sharethis.com/js/sharethis.js#property=5bdb3d0b4f97b900113a91e1&product=inline-share-buttons';

            // ShareThis code must be inserted at the end of the <head> element
            document.getElementsByTagName('head')[0].appendChild(this.shareThis);

            // Resolve the promise after the script has loaded
            this.shareThis.onload = () => {
                resolve();
            }
        }).then(() => {
            this.forceUpdate();
        });
    }

    render() {
        return (
            <div className="sharethis-inline-share-buttons rec-share-btn" />
        );
    }
}
